import { GridLayout } from "@arelia-components/layout/GridLayout";
import { Widget } from "@arelia-types/widget";
import { Box } from "@mui/material";
import { hqWidgets } from "./widgets/config";

export default function HqDashboardPresenter() {
  return <GridLayout>
    {hqWidgets.map((widgetConfig: Widget) => {
      const { size, height, component: Component, id } = widgetConfig;

      return (
        <Box key={id}
          gridColumn={`span ${size}`}
          gridRow={`span ${height}`}
        >
          <Component config={widgetConfig} />
        </Box>
      )
    })}
  </GridLayout>;
}
